import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../components/Loader"; // Importación
import "../styles/DetalleEntidad.css"; 

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';
const diasSemana = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];

export default function AduanaDetalle() {
  const { id } = useParams();
  const [aduana, setAduana] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/Aduanas/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Aduana no encontrada");
        return res.json();
      })
      .then((data) => setAduana(data))
      .catch(() => navigate("/aduanas-y-puertos"));
  }, [id, navigate]);

  // Implementación del Loader
  if (!aduana) return <Loader message="Cargando información de la aduana..." />;

  const { nombre, telefono, horario, municipio, estado, direccion } = aduana;

  return (
    <div className="entidad-detalle-container">
      <div className="entidad-header">
        <h2>DETALLES DE LA ADUANA</h2>
        <button className="entidad-cerrar-btn" onClick={() => navigate(-1)}>✕</button>
      </div>

      <div className="entidad-detalle-content">
        <div className="entidad-col-izquierda">
          <h3>{nombre}</h3>
          
          <div className="entidad-seccion">
            <h4>📌 Información</h4>
            <p><strong>Estado:</strong> {estado}</p>
            <p><strong>Municipio:</strong> {municipio}</p>
          </div>

          <div className="entidad-seccion">
            <h4>🕒 Horario de atención</h4>
            <table className="entidad-horario-tabla">
              <tbody>
                {diasSemana.map((dia) => {
                  const dataDia = horario?.[dia]; 
                  if (!dataDia || dataDia.length === 0) {
                    return (
                      <tr key={dia}>
                        <td>{dia}</td>
                        <td className="cerrado">cerrado</td>
                      </tr>
                    );
                  }
                  
                  return dataDia.map((h, index) => (
                    <tr key={`${dia}-${index}`}>
                      <td>{index === 0 ? dia : ""}</td>
                      <td>{h.abre} - {h.cierra}</td>
                    </tr>
                  ));
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="entidad-col-derecha">
          <p>📍 {direccion || 'Dirección no disponible'}</p>
          <p>📞 {telefono || 'Teléfono no disponible'}</p>
        </div>
      </div>
    </div>
  );
}